// Apresentação apenas. A autorização e a carteira continuam no backend.
export function supervisorVisualizaTodos(perfil, tenant) {
  return String(tenant || '').trim().toLowerCase() === 'macmillan'
    && String(perfil || '').trim().toLowerCase() === 'supervisor';
}

export function dashboardSomenteDoacao(perfil, tenant) {
  const nome = String(perfil || '').trim().toLowerCase();
  return ['representante', 'supervisor'].includes(nome)
    && !supervisorVisualizaTodos(perfil, tenant);
}
